export  const PasswordValidityEnum= {
    NONE: "none",
    VALID: "valid",
    INVALID: "invalid",
    EMPTY: "empty",
    NOT_SAME: "notSame"
}